import * as React from 'react';
import { Grid } from '@material-ui/core';
import { WhiteLabelMobileButton, Magnetic } from '@mitchell/react.component.ux';
import { TranslationService } from "../../common";
import { PhotoCaptureConstants, PhotoCaptureScriptQuestionIds } from '../constants';
import { StyledSmallButton } from './PhotoCaptureNavigationControlComponent.style';
export const PhotoCaptureNavigationControlComponent = ({ idPrefix, shouldNextButtonDisabled, rightButtonLabel, leftButtonLabel, buttonBackgroundColor, buttonTextColor, disabledButtonBackgroundColor, disabledButtonTextColor, finishButtonBackgroundColor, finishButtonTextColor, selectedButtonBackgroundColor, isRightBtnSelected, isLeftBtnSelected, onLeftClick, onRightClick, leftButtonIcon, secondaryButtonBackgroundColor, secondaryButtonTextColor, shouldAllowMitchellIntelligent, shouldLeftButtonDisabled }) => {
    const translateFn = TranslationService.translate;
    const getRightButtonBackgroundColor = () => {
        if (shouldNextButtonDisabled)
            return disabledButtonBackgroundColor;
        else if (isRightBtnSelected)
            return selectedButtonBackgroundColor || buttonBackgroundColor;
        else
            return finishButtonBackgroundColor || buttonBackgroundColor;
    };
    const getLeftButtonBackgroundColor = () => {
        if (shouldLeftButtonDisabled)
            return disabledButtonBackgroundColor;
        if (shouldAllowMitchellIntelligent) {
            return secondaryButtonBackgroundColor || buttonBackgroundColor;
        }
        else if (isLeftBtnSelected) {
            return selectedButtonBackgroundColor || buttonBackgroundColor;
        }
        else {
            return buttonBackgroundColor;
        }
    };
    const getLeftButtonTextColor = () => {
        if (shouldAllowMitchellIntelligent) {
            return secondaryButtonTextColor || buttonTextColor;
        }
        else {
            return buttonTextColor;
        }
    };
    return (React.createElement(Grid, { container: true, justify: "center", direction: "row", wrap: "nowrap" },
        React.createElement(StyledSmallButton, { container: true, color: getLeftButtonTextColor() },
            React.createElement(WhiteLabelMobileButton, { id: `${idPrefix}_${PhotoCaptureScriptQuestionIds.ID_PREVIOUS_BUTTON}`, label: translateFn(leftButtonLabel || PhotoCaptureConstants.PREVIOUS), buttonTextColor: shouldLeftButtonDisabled ? disabledButtonTextColor : getLeftButtonTextColor(), onClick: () => onLeftClick(), buttonBackgroundColor: getLeftButtonBackgroundColor(), icon: leftButtonIcon, iconColor: getLeftButtonTextColor(), isDisabled: shouldLeftButtonDisabled })),
        React.createElement(StyledSmallButton, { container: true, marginLeft: Magnetic.spacer06, color: shouldNextButtonDisabled ? disabledButtonTextColor : finishButtonTextColor || buttonTextColor },
            React.createElement(WhiteLabelMobileButton, { id: `${idPrefix}_${PhotoCaptureScriptQuestionIds.ID_NEXT_BUTTON}`, label: translateFn(rightButtonLabel || PhotoCaptureConstants.NEXT), buttonBackgroundColor: getRightButtonBackgroundColor(), buttonTextColor: shouldNextButtonDisabled ? disabledButtonTextColor : finishButtonTextColor || buttonTextColor, onClick: () => onRightClick(), isDisabled: shouldNextButtonDisabled }))));
};
//# sourceMappingURL=PhotoCaptureNavigationControlComponent.js.map